const DojoAbstractTransactionCreateRequestRecord = require('./DojoAbstractTransactionCreateRequestRecord');

class DojoTransactionRefundRequestRecord extends DojoAbstractTransactionCreateRequestRecord {
    /**
     * @param {DojoConfig} config
     * @param {} payload
     */
    constructor(config, payload) {
        super(
            config,
            payload,
            'REFUND'
        );
    }
}

module.exports = DojoTransactionRefundRequestRecord;
